import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SEND_LOGIN_OTP } from '../../redux/constant';
import ConfirmPassword from './ConfirmPassword';
import { ButtonLoader } from '../../component/common/Loader';

const OtpInput = (phoneNo = 0, restaurantId) => {
  const isNumber = (value) => !isNaN(value);
  const [otp, setOtp] = useState(['', '', '', '']);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [error, setError] = useState('');

  const dispatch = useDispatch();
  const otpSuccess = useSelector((state) => state?.admin?.flags?.otpSuccess);
  const otpError = useSelector((state) => state?.admin?.flags?.otpError);
  const loading = useSelector((state) => state.admin.loading); // or state.admin.loading
  // todo: otpError should be handled in redux state
   console.log("OtpInput otpSuccess",otpSuccess)
   console.log("OtpInput otpError",otpError)
  useEffect(() => {
    // Any side effects or initializations can be done here
    if(otpSuccess !== false)
    setConfirmPassword(!confirmPassword);
  }, [otpSuccess]);

  const handleLogin = () => {
    // Here you would typically make an API call to your backend
    // to verify the entered OTP and authenticate the user.
    // For this example, we'll simulate a successful login.
    console.log("phoneNumber",phoneNo.phoneNo)
      console.log("otp",otp)
      const otpValue = otp.join('');
      const phoneNumber = phoneNo.phoneNo;
    if (otpValue.length === 4) {
      // Assuming OTP is 4 digits long

      dispatch({ type: SEND_LOGIN_OTP, payload: {phoneNumber, otpValue} })
    } else {
      setError('Please enter a valid OTP.');
    }
  };

  const handleOtpChange = (index, value) => {

    const newOtp = [...otp];
    if (isNumber(value)) {
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically focus on the next input field
      if (value && index < 3) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      } else if (value) {
        const loginBtn = document.getElementById('btn-login');
        if (loginBtn) {
          loginBtn.focus();
        }
      }
    }
  };

  return (confirmPassword ? <>
    <div className="otp-container">
      {/* <input
        // key={index}
        id={`otp-test`}
        type="otp"
        maxLength="1"
        // value={digit}
        onChange={(e) => { }}
        onKeyDown={(e) => {
          // if (e.key === 'Backspace' && index > 0) {
          //   const prevInput = document.getElementById(`otp-${index - 1}`);
          //   if (prevInput) {
          //     prevInput.focus();
          //   }
          // }
        }}
      /> */}
      {otp.map((digit, index) => (
        <React.Fragment key={index}>
          <input
            key={index}
            id={`otp-${index}`}
            type="text"
            className="loginInput otp"
            maxLength="1"
            value={digit}
            onChange={(e) => handleOtpChange(index, e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Backspace' && index > 0 && (index === otp.length - 1 && !digit || index !== otp.length - 1)) {
                const prevInput = document.getElementById(`otp-${index - 1}`);
                if (prevInput) {
                  prevInput.focus();
                }
              }
            }}
          />
          {/* {index !== otp.length - 1 && <div style={{textAlign: 'center'}}>-</div>} */}
        </React.Fragment>
      ))}
    </div>
    {error || otpError && (
      <div className="error-message" style={{ color: "var(--ui-danger-text)", marginBottom: '10px' }}>
        {otpError ? otpError : error}
      </div>
    )}
    <button id='btn-login' onClick={handleLogin} className='full-btn'>
      {loading ? <ButtonLoader label="Confirming OTP..." /> : "Confirm OTP"}
    </button>
  </>
    :
    <ConfirmPassword phoneNo={phoneNo} restaurantId={restaurantId} />
  );
};

export default OtpInput;
